/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle/7-L': {
    width: 56,
    height: 56,
    viewBox: '0 0 56 56',
    data: '<path pid="0" d="M0 0h56v56H0V0zm28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28zm0-1C13.088 55 1 42.912 1 28S13.088 1 28 1s27 12.088 27 27-12.088 27-27 27zm-5.588-34.576v2.508h7.612L23.666 36h3.102l6.226-13.156v-2.42H22.412z" _fill="#D8D8D8" fill-rule="nonzero"/>'
  }
})
